module.exports = __webpack_public_path__ + "img/SC12-Next_steps.4e96917a.png";